import { RouteComponentProps } from "@reach/router";
import Layout from "../layout/Layout";
import RecallsPickList from "../List/RecallsPickList";
import { EntityNames } from "../../../enums/EntityNames";

export default function RecallsPickingPage(props: RouteComponentProps) {
    return (
        <Layout entityName={EntityNames.pickList} pageTitle={`Pick List`} data={{}} showBackButton={true} showBreadcrumb={false} canScroll={true}>
            <RecallsPickList />
        </Layout>
    )
}